import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Col,
    CardBody,
    Card,
    Container,
    Form,
    FormGroup,
    Input,
    Label
} from 'reactstrap'
import { withRouter, Link } from 'react-router-dom'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import profile from '../../assets/images/profile-img.png'
import logo from '../../assets/images/logo.svg'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'

const ForgotPassword = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [userId, setUserId] = useState(props.userId)
    const [email, setEmail] = useState()
    const [code, setCode] = useState()
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [step, setStep] = useState(1)

    useEffect(() => {
        window.analytics.page('Password Recovery Page Viewed')
    }, [])

    // email
    const _handleStep1 = async (e) => {
        try {
            e.preventDefault()
            setLoading(true)
            const response = await ApiService.forgetPassword({ email })

            if (!response.data.success) {
                toastr.error(`No pude encontrar tu usuario, revisa que hayas escrito bien tu correo`)
                return
            }

            setUserId(response.data.userId)
            window.analytics.track("Password Recovery Initiated", {
                userId: response.data.userId
            })

            setStep(2)
        } catch (e) {
            if (e.response) {
                if (e.response.data.message) {
                    toastr.error(`${e.response.data.message}`, 'Error')
                } else {
                    toastr.error(`No pude encontrar tu usuario, revisa que hayas escrito bien tu correo`, 'Error')
                }
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    // validate code
    const _handleStep2 = async (e) => {
        try {
            e.preventDefault()
            setLoading(true)
            const response = await ApiService.validateForgotPasswordCode({ userId, code })
            if (!response.data.success) {
                toastr.error(`Este código tal vez ya expiró o lo escribiste mal`)
                return
            }

            window.analytics.track("Password Recovery Code Validated", { userId })

            setStep(3)
        } catch (e) {
            if (e.response) {
                if (e.response.data.message) {
                    toastr.error(`${e.response.data.message}`, 'Error')
                } else {
                    toastr.error(`Este código tal vez ya expiró o lo escribiste mal`, 'Error')
                }
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    // update password
    const _handleStep3 = async (e) => {
        try {
            e.preventDefault()
            if (password !== confirmPassword) {
                toastr.error(`Las contraseñas no coinciden`)
                return
            }
            setLoading(true)
            const response = await ApiService.updatePassword({ userId, password })
            if (!response.data.success) {
                toastr.error(`Tuve un problema para actualizar tu password, ¿Lo intentas de nuevo?`)
                return
            }

            window.analytics.track("Password Recovery Completed", { userId })
            window.location.href = `/login`
        } catch (e) {
            if (e.response) {
                if (e.response.data.message) {
                    toastr.error(`${e.response.data.message}`, 'Error')
                } else {
                    toastr.error(`Tuve un problema para actualizar tu password, ¿Lo intentas de nuevo?`)
                }
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    const _render = () => {
        if (step === 1 ) { return _renderStep1() }
        if (step === 2 ) { return _renderStep2() }
        if (step === 3 ) { return _renderStep3() }
    }

    const _renderStep1 = () => {
        return (
            <Form id="create" method="POST" onSubmit={ _handleStep1 }>
                <FormGroup>
                    <Label htmlFor="name">
                        Email *
                    </Label>
                    <Input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={email}
                        placeholder="Ingrese su email"
                        onChange={event => setEmail(event.target.value)}
                    />
                </FormGroup>
                <div className="mt-3">
                    <button
                        className="btn btn-primary btn-block waves-effect waves-light"
                        type="submit">
                        Recuperar Contraseña
                    </button>
                </div>
            </Form>
        )
    }

    const _renderStep2 = () => {
        return(
            <Form id="create" method="POST" onSubmit={ _handleStep2 }>
                <FormGroup>
                    <Label htmlFor="name">
                        Código de Verificación *
                    </Label>
                    <Input
                        type="number"
                        className="form-control"
                        id="code"
                        name="code"
                        value={code}
                        onChange={event => setCode(event.target.value)}
                    />
                </FormGroup>
                <div className="mt-3">
                    <button
                        className="btn btn-primary btn-block waves-effect waves-light"
                        type="submit">
                        Validar Código
                    </button>
                </div>
            </Form>
        )
    }

    const _renderStep3 = () => {
        return(
            <Form id="create" method="POST" onSubmit={ _handleStep3 }>
                <FormGroup>
                    <Label htmlFor="name">
                        Contraseña
                    </Label>
                    <Input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        value={password}
                        onChange={event => setPassword(event.target.value)}
                    />
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="name">
                        Confirmar Contraseña
                    </Label>
                    <Input
                        type="password"
                        className="form-control"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={event => setConfirmPassword(event.target.value)}
                    />
                </FormGroup>
                <div className="mt-3">
                    <button
                        className="btn btn-primary btn-block waves-effect waves-light"
                        type="submit">
                        Actualizar Contraseña
                    </button>
                </div>
            </Form>
        )
    }

    return(
        <React.Fragment>
            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark"><i className="bx bx-home h2"></i></Link>
            </div>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden">
                                <div className="bg-soft-primary">
                                    <Row>
                                        <Col className="col-7">
                                            <div className="text-primary p-4">
                                                <h5 className="text-primary">
                                                    ¡Bienvenido/a!
                                                </h5>
                                                <p>
                                                    Recupera tu cuenta Vendora.
                                                </p>
                                            </div>
                                        </Col>
                                        <Col className="col-5 align-self-end">
                                            <img
                                                src={profile}
                                                alt=""
                                                className="img-fluid"
                                            />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div>
                                        <Link to="/">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src={logo}
                                                        alt=""
                                                        className="rounded-circle"
                                                        height="34"
                                                    />
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="p-2">
                                        { _render() }
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(ForgotPassword)